var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"main-wrapper"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.text.ravintoloille.mainHeader))]),_c('p',[_vm._v(_vm._s(_vm.text.ravintoloille.mainStory))])]),_c('v-spacer'),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Takaisin etusivulle ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }